import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isBusy, withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { push } from "connected-react-router";
import { Button, Select, Spin } from "antd";

import "./fundingLimit.less";
import MapProductLender from "./fundingLimitComponents/productLenderMap";
import { getLendersList, saveNewCycleData } from "./fundingLimitActions";
import { getLenderId, getRole } from "../../common/helpers";
import { ACTION_MAPPING } from "./constants";
import _ from "lodash";
@connect(
  ({ localize, funding: { action, products, lenders, newCycle } }) => ({
    translate: getTranslate(localize),
    action,
    products,
    lenders,
    newCycle,
    loading: isBusy(getLendersList),
  }),
  (dispatch) => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  getLendersList,
  saveNewCycleData,
})
class ProductLenderMapping extends Component {
  constructor() {
    super();
    this.state = {
      productLenderMapValidations: new Map(),
    };
    this.setValidationState = this.setValidationState.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.updateProductValidationsState =
      this.updateProductValidationsState.bind(this);
    this.goNextState = this.goNextState.bind(this);
    this.getInitialState = this.getInitialState.bind(this);
  }

  async componentWillMount() {
    const role = await getRole();
    const lenderId = await getLenderId();
    this.setState({ currentLenderId: lenderId, role });
  }

  async componentDidMount() {
    const params = {
      status: "pending",
    };

    this.saveDropdownChange = this.saveDropdownChange.bind(this);

    if (_.isEmpty(this.props.lenders)) {
      this.props.getLendersList(params);
    }
  }

  goNextState = (isValidInput) => {
    if (isValidInput) {
      this.props.nextStepClicked();
    }
  };

  setValidationState = (products) => {
    let initialValidationState = this.getInitialState(products);
    this.setState(() => {
      return {
        productLenderMapValidations: initialValidationState,
      };
    });
  };

  updateProductValidationsState = (
    currentValidationState,
    product,
    isEmpty,
    isEmptyMessage
  ) => {
    currentValidationState.set(product, {
      isEmpty: isEmpty,
      isEmptyMessage: isEmptyMessage,
    });
  };

  getInitialState = (products) => {
    const newProductLenderMapValidations = new Map();
    products.forEach((product) => {
      newProductLenderMapValidations.set(product.code, {
        isEmpty: false,
        isEmptyMessage: false,
      });
    });
    return newProductLenderMapValidations;
  };

  checkValidation = (products, newCycle, translate) => {
    let newValidationState = this.getInitialState(products);
    let isValidInput = true;
    products.forEach((product) => {
      const productValue = newCycle[product.code];
      const allSelectedLenders = _.keys(productValue.lenders);
      if (allSelectedLenders.length === 0) {
        this.updateProductValidationsState(
          newValidationState,
          product.code,
          true,
          translate('errorMessages.ovo_admin_error_select_lender')
        );
        isValidInput = false;
      }
    });
    this.setState((prevState) => {
      return {
        productLenderMapValidations: newValidationState,
      };
    });
    this.goNextState(isValidInput);
  };

  saveDropdownChange = (productID, value) => {
    const data = {
      productID,
      lenders: value,
    };
    this.props.saveNewCycleData(ACTION_MAPPING.saveProductLenderMap, data);
    let newValidationState = this.state.productLenderMapValidations;
    this.updateProductValidationsState(
      newValidationState,
      productID,
      false,
      ""
    );
    this.setState((prevState) => {
      return {
        productLenderMapValidations: newValidationState,
      };
    });
  };

  getLenderDropdownList = () => {
    const { Option } = Select;
    const children = [];
    const { lenders } = this.props;
    lenders.map((lender) => {
      return children.push(
        <Option key={lender.lender_id} value={lender.lender_id}>{lender.lender_name}</Option>
      );
    });

    return children;
  };

  renderPageContent = () => {
    const { translate, products, newCycle } = this.props,
      lenderList = this.getLenderDropdownList();
    return products.map((product) => {
      const productCycle = newCycle[product.code];
      const productLender = newCycle[product.code].lenders;
      if (productCycle.product_limit_snapshot > 0) {
        return (
          <MapProductLender
            translate={translate}
            product={product}
            lenderList={lenderList}
            handleChange={this.saveDropdownChange}
            mappedLenders={_.keysIn(productLender)}
            isEmpty={
              this.state.productLenderMapValidations.has(product.code)
                ? this.state.productLenderMapValidations.get(product.code)
                    .isEmpty
                : false
            }
            isEmptyMessage={
              this.state.productLenderMapValidations.has(product.code)
                ? this.state.productLenderMapValidations.get(product.code)
                    .isEmptyMessage
                : false
            }
          />
        );
      } else {
        return <></>;
      }
    });
  };

  renderButtonForNavigation = () => {
    const { translate, products, newCycle } = this.props;
    return (
      <>
        <Button type="secondary" onClick={this.props.prevStepClicked}>
          {translate("fundingLimit.back")}
        </Button>
        <Button
          type="primary"
          onClick={() => this.checkValidation(products, newCycle, translate)}
        >
          {translate("fundingLimit.button_next")}
        </Button>
      </>
    );
  };

  render() {
    const { loading, translate } = this.props;
    if (loading) {
      return <Spin tip={translate("generic.loadingData")} size="large" />;
    }
    return (
      <div className="product-lender-map-container">
        {this.renderPageContent()}
        {this.renderButtonForNavigation()}
      </div>
    );
  }
}

export default ProductLenderMapping;
